import { useEffect, useRef } from 'react';
import { create } from 'zustand';
import type { ModuleName } from '@otc/shared';

interface ExtraDraft { save: () => Promise<boolean>; discard: () => void }
export const useExtraDrafts = create<{ entries: Partial<Record<ModuleName, ExtraDraft>> }>(() => ({ entries: {} }));

/** Для месячных выплат, которые сохраняются отдельным API, но под общей защитой раздела. */
export function useExtraDraft(module: ModuleName, dirty: boolean, draft: ExtraDraft) {
  const latest = useRef(draft);
  latest.current = draft;
  useEffect(() => {
    if (!dirty) return;
    const entry = { save: () => latest.current.save(), discard: () => latest.current.discard() };
    useExtraDrafts.setState(s => ({ entries: { ...s.entries, [module]: entry } }));
    return () => useExtraDrafts.setState(s => {
      const entries = { ...s.entries };
      if (entries[module] === entry) delete entries[module];
      return { entries };
    });
  }, [module, dirty]);
}
